<template>
  <div class="call_section stores_section">
    <div class="wrapper">
      <div class="container margin_80_55">
        <div class="main_title_2">
          <span><em /></span>
          <h2>{{ $t('lang.home.stores.title') }}</h2>
          <h3>{{ $t('lang.home.stores.subtitle') }}</h3>
        </div>
        <div class="row justify-content-center">
          <div class="benefits">
            <div class="benefit">
              <span class="icon">💰</span>
              <p>{{ $t('lang.home.stores.benefits_1') }}</p>
            </div>
            <div class="benefit">
              <span class="icon">📢</span>
              <p>{{ $t('lang.home.stores.benefits_2') }}</p>
            </div>
            <div class="benefit">
              <span class="icon">⚡</span>
              <p>{{ $t('lang.home.stores.benefits_3') }}</p>
            </div>
          </div>
        </div>
        <!-- /row -->
        <p
          class="text-center add_top_30 wow bounceIn"
          data-wow-delay="0.5s"
          style="visibility: visible; animation-delay: 0.5s; animation-name: bounceIn;"
        >
          <a
            :href="'https://store.wekeep.app/lang/'+$store.state.main.lang+'/register'"
            class="btn_1 rounded"
            target="_blank"
          >{{ $t('lang.home.stores.button') }}</a>
        </p>
      </div>
    </div>
    <!-- /wrapper -->
  </div>
</template>

<script>
export default {
  name: 'StoresSite',

  data() {
    return {
    };
  },
};
</script>

<style scoped>
.benefits {
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
  flex-wrap: wrap;
}
.benefit {
  text-align: center;
  width: 30%;
  min-width: 180px;
  display:flex;
  align-items: center;
  flex-direction: column;
}
.icon {
  font-size: 30px;
  background: rgba(255,255,255,0.2);
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.benefit p {
  margin-top: 10px;
  font-size: 14px;
  font-weight: bold;
}

/* Versión Mobile */
@media (max-width: 768px) {
  .icon {
    font-size: 25px;
    background: rgba(255,255,255,0.2);
    width: 50px;
    height: 50px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
  }
  .benefit p {
    margin:0;
    font-size: 14px;
    font-weight: bold;
  }
  .benefits{
    display: flex;
    flex-direction: column;
  }
  .benefit{
    margin-bottom: 10px;
    display:flex;
    align-items: center;
    flex-direction: row;
    width: 100%;
  }
}
</style>
